<template>
  <div class="task-list-skeleton-wrapper">
    <div class="task-list-skeleton" v-if="isLoading">
      <div v-for="i in itemsCount" :key="i" class="task-item">
        <div class="circle"></div>
        <div class="task-content">
          <div class="skeleton-block long"></div>
          <div class="skeleton-block short"></div>
        </div>
      </div>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
    itemsCount: {
      type: Number,
      default: 4,
    },
  },
};
</script>

<style lang="scss" scoped>
.task-list-skeleton {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  background: #fff;
  border-radius: 8px;

  &-wrapper {
    height: 100%;
  }
}

.task-item {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #E4E4E4;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
}

.circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
}

.task-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.skeleton-block {
  border-radius: 4px;
  background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;

  &.long {
    width: 80%;
    height: 18px;
  }

  &.short {
    width: 50%;
    height: 14px;
  }
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
